// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Controles: botões, campos compactos, menu de acesso e gaveta de diagnóstico. */

.botao {
  padding: 5px var(--espaco-3);
  background: var(--papel);
  border: 1px solid var(--linha-forte);
  border-radius: var(--raio);
  color: var(--tinta);
  font-size: var(--texto-sm);
  cursor: pointer;
  text-decoration: none;
  transition:
    background var(--transicao),
    border-color var(--transicao),
    color var(--transicao);
}

a.botao,
a.botao:hover,
a.botao:focus {
  text-decoration: none;
}

.botao:hover:not(:disabled) {
  background: var(--papel-2);
  border-color: var(--tinta-suave);
}

.botao:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.botao--primario {
  background: var(--realce);
  border-color: var(--realce);
  color: #ffffff;
  font-weight: 600;
}

.botao--primario:hover:not(:disabled) {
  background: color-mix(in srgb, var(--realce) 88%, black);
  border-color: color-mix(in srgb, var(--realce) 88%, black);
}

.botao--secundario {
  background: var(--superficie);
  border-color: var(--linha-forte);
  color: var(--tinta);
  font-weight: 500;
}

.botao--secundario:hover:not(:disabled) {
  background: var(--superficie-2);
  border-color: var(--verde-primario);
  color: var(--verde-institucional);
}

.botao--perigo {
  border-color: color-mix(in srgb, var(--erro) 32%, var(--linha-forte));
  color: var(--erro);
}

.botao--perigo:hover:not(:disabled) {
  background: color-mix(in srgb, var(--erro) 6%, var(--papel));
}

.botao--discreto {
  padding: 4px var(--espaco-2);
  background: none;
  border-color: transparent;
  color: var(--tinta-media);
  font-size: var(--texto-xs);
}

.botao--discreto:hover:not(:disabled) {
  background: var(--papel-2);
  border-color: var(--linha);
}

/* Botão de ícone: alvo mínimo confortável, sem peso visual. */
.botao-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--espaco-2);
  min-width: 28px;
  height: 28px;
  padding: 0 var(--espaco-2);
  background: none;
  border: 1px solid transparent;
  border-radius: var(--raio);
  color: var(--tinta-media);
  font-size: var(--texto-xs);
  cursor: pointer;
  transition:
    background var(--transicao),
    color var(--transicao);
}

.botao-icone:hover:not(:disabled) {
  background: var(--papel-2);
  color: var(--tinta);
}

.botao-icone:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.botao-icone[aria-pressed='true'],
.botao-icone[aria-expanded='true'] {
  background: var(--realce-fraco);
  color: var(--realce);
}

.acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  flex-wrap: wrap;
}

/* --- Campos -------------------------------------------------------------- */

.campo {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
}

.campo__rotulo {
  color: var(--tinta-media);
  font-size: var(--texto-xs);
}

.campo__entrada,
.campo__selecao {
  width: 100%;
  padding: 5px var(--espaco-2);
  background: var(--papel);
  border: 1px solid var(--linha-forte);
  border-radius: var(--raio);
  color: var(--tinta);
  font-size: var(--texto-sm);
  transition: border-color var(--transicao);
}

.campo__entrada::placeholder {
  color: var(--tinta-suave);
}

.campo__entrada:hover,
.campo__selecao:hover {
  border-color: var(--tinta-suave);
}

.campo__entrada:focus,
.campo__selecao:focus {
  border-color: var(--realce);
}

.campo__auxilio {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

/* Busca da lista de feições: sem rótulo visível, com ícone à esquerda. */
.busca {
  position: relative;
  display: block;
}

.busca__icone {
  position: absolute;
  left: var(--espaco-2);
  top: 50%;
  transform: translateY(-50%);
  color: var(--tinta-suave);
  pointer-events: none;
}

.busca .campo__entrada {
  padding-left: 26px;
}

/* --- Menu suspenso ------------------------------------------------------- */

.menu {
  position: relative;
}

.menu__painel {
  position: absolute;
  top: calc(100% + var(--espaco-2));
  right: 0;
  z-index: 30;
  width: 288px;
  padding: var(--espaco-3);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-flutuante);
}

.menu__titulo {
  margin-bottom: var(--espaco-2);
  font-size: var(--texto-sm);
  font-weight: 600;
}

.menu__formulario {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
}

/* --- Gaveta de diagnóstico ----------------------------------------------- */

.gaveta__leituras {
  display: flex;
  flex-wrap: wrap;
  gap: var(--espaco-3) var(--espaco-5);
  padding: var(--espaco-3);
}

.gaveta__item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.gaveta__item--largo {
  max-width: 100%;
  flex: 1 1 240px;
}

.gaveta__rotulo {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  line-height: 1.2;
}

.gaveta__valor {
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gaveta__valor[data-falha='sim'] {
  color: var(--erro);
}

.gaveta__erro {
  flex: 1 1 100%;
  padding-top: var(--espaco-2);
  border-top: 1px solid var(--linha);
}

.gaveta__erro .gaveta__rotulo {
  color: var(--erro);
  font-family: var(--fonte-dados);
}

.gaveta__erro .gaveta__valor {
  white-space: normal;
  color: var(--tinta-media);
}

.gaveta__vazio {
  padding: var(--espaco-3);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}
`, "",{"version":3,"sources":["webpack://./src/styles/controles.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB;;;0BAGwB;AAC1B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":["/* Controles: botões, campos compactos, menu de acesso e gaveta de diagnóstico. */\r\n\r\n.botao {\r\n  padding: 5px var(--espaco-3);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha-forte);\r\n  border-radius: var(--raio);\r\n  color: var(--tinta);\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition:\r\n    background var(--transicao),\r\n    border-color var(--transicao),\r\n    color var(--transicao);\r\n}\r\n\r\na.botao,\r\na.botao:hover,\r\na.botao:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.botao:hover:not(:disabled) {\r\n  background: var(--papel-2);\r\n  border-color: var(--tinta-suave);\r\n}\r\n\r\n.botao:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.botao--primario {\r\n  background: var(--realce);\r\n  border-color: var(--realce);\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n}\r\n\r\n.botao--primario:hover:not(:disabled) {\r\n  background: color-mix(in srgb, var(--realce) 88%, black);\r\n  border-color: color-mix(in srgb, var(--realce) 88%, black);\r\n}\r\n\r\n.botao--secundario {\r\n  background: var(--superficie);\r\n  border-color: var(--linha-forte);\r\n  color: var(--tinta);\r\n  font-weight: 500;\r\n}\r\n\r\n.botao--secundario:hover:not(:disabled) {\r\n  background: var(--superficie-2);\r\n  border-color: var(--verde-primario);\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.botao--perigo {\r\n  border-color: color-mix(in srgb, var(--erro) 32%, var(--linha-forte));\r\n  color: var(--erro);\r\n}\r\n\r\n.botao--perigo:hover:not(:disabled) {\r\n  background: color-mix(in srgb, var(--erro) 6%, var(--papel));\r\n}\r\n\r\n.botao--discreto {\r\n  padding: 4px var(--espaco-2);\r\n  background: none;\r\n  border-color: transparent;\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.botao--discreto:hover:not(:disabled) {\r\n  background: var(--papel-2);\r\n  border-color: var(--linha);\r\n}\r\n\r\n/* Botão de ícone: alvo mínimo confortável, sem peso visual. */\r\n.botao-icone {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--espaco-2);\r\n  min-width: 28px;\r\n  height: 28px;\r\n  padding: 0 var(--espaco-2);\r\n  background: none;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n  cursor: pointer;\r\n  transition:\r\n    background var(--transicao),\r\n    color var(--transicao);\r\n}\r\n\r\n.botao-icone:hover:not(:disabled) {\r\n  background: var(--papel-2);\r\n  color: var(--tinta);\r\n}\r\n\r\n.botao-icone:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.botao-icone[aria-pressed='true'],\r\n.botao-icone[aria-expanded='true'] {\r\n  background: var(--realce-fraco);\r\n  color: var(--realce);\r\n}\r\n\r\n.acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* --- Campos -------------------------------------------------------------- */\r\n\r\n.campo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n}\r\n\r\n.campo__rotulo {\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.campo__entrada,\r\n.campo__selecao {\r\n  width: 100%;\r\n  padding: 5px var(--espaco-2);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha-forte);\r\n  border-radius: var(--raio);\r\n  color: var(--tinta);\r\n  font-size: var(--texto-sm);\r\n  transition: border-color var(--transicao);\r\n}\r\n\r\n.campo__entrada::placeholder {\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.campo__entrada:hover,\r\n.campo__selecao:hover {\r\n  border-color: var(--tinta-suave);\r\n}\r\n\r\n.campo__entrada:focus,\r\n.campo__selecao:focus {\r\n  border-color: var(--realce);\r\n}\r\n\r\n.campo__auxilio {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n/* Busca da lista de feições: sem rótulo visível, com ícone à esquerda. */\r\n.busca {\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n.busca__icone {\r\n  position: absolute;\r\n  left: var(--espaco-2);\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: var(--tinta-suave);\r\n  pointer-events: none;\r\n}\r\n\r\n.busca .campo__entrada {\r\n  padding-left: 26px;\r\n}\r\n\r\n/* --- Menu suspenso ------------------------------------------------------- */\r\n\r\n.menu {\r\n  position: relative;\r\n}\r\n\r\n.menu__painel {\r\n  position: absolute;\r\n  top: calc(100% + var(--espaco-2));\r\n  right: 0;\r\n  z-index: 30;\r\n  width: 288px;\r\n  padding: var(--espaco-3);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-flutuante);\r\n}\r\n\r\n.menu__titulo {\r\n  margin-bottom: var(--espaco-2);\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n}\r\n\r\n.menu__formulario {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n/* --- Gaveta de diagnóstico ----------------------------------------------- */\r\n\r\n.gaveta__leituras {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--espaco-3) var(--espaco-5);\r\n  padding: var(--espaco-3);\r\n}\r\n\r\n.gaveta__item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n.gaveta__item--largo {\r\n  max-width: 100%;\r\n  flex: 1 1 240px;\r\n}\r\n\r\n.gaveta__rotulo {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  line-height: 1.2;\r\n}\r\n\r\n.gaveta__valor {\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  font-variant-numeric: tabular-nums;\r\n  line-height: 1.3;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.gaveta__valor[data-falha='sim'] {\r\n  color: var(--erro);\r\n}\r\n\r\n.gaveta__erro {\r\n  flex: 1 1 100%;\r\n  padding-top: var(--espaco-2);\r\n  border-top: 1px solid var(--linha);\r\n}\r\n\r\n.gaveta__erro .gaveta__rotulo {\r\n  color: var(--erro);\r\n  font-family: var(--fonte-dados);\r\n}\r\n\r\n.gaveta__erro .gaveta__valor {\r\n  white-space: normal;\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.gaveta__vazio {\r\n  padding: var(--espaco-3);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
